import { defaultHttpClient } from '../../httpClient';
import type { RelatedKeywordsResponse } from '../types';

export const getRelatedKeywords = async (params: {
  query: string;
  search_type: string;
}) => {
  return defaultHttpClient
    .request<RelatedKeywordsResponse>({
      method: 'GET',
      url: '/api/v2/search/query_recommend/',
      params,
    })
    .then(result => result.data);
};
